import React, { Suspense, useEffect, useState } from "react";

const ActionComponentList = ({
  actionList,
  email,
  currentPage,
  sizeNumber,
  setLoading,
  setSubUsers,
  setNumberOfUsers,
  fieldToOrder,
  orderAscending,
  permission,
  isMobile,
  fullName,
  firstName,
  phoneNumber,
  profilePicture,
}) => {
  const [сomponentList, setComponentList] = useState([]);

  useEffect(() => {
    if (actionList) {
      actionList.map((action) => {
        const ActionComponent = React.lazy(() =>
          import(`./Actions/${action}Action.js`)
        );
        setComponentList((prev) => [...prev, ActionComponent]);
      });

      return () => {
        setComponentList([]);
      };
    }
  }, [actionList]);

  return (
    <Suspense>
      {сomponentList.map((Component, index) => {
        return Component ? (
          <Component
            key={actionList[index] + index}
            {...{
              email,
              currentPage,
              sizeNumber,
              setLoading,
              setSubUsers,
              setNumberOfUsers,
              fieldToOrder,
              orderAscending,
              permission,
              isMobile,
              fullName,
              firstName,
              phoneNumber,
              profilePicture,
            }}
          />
        ) : null;
      })}
    </Suspense>
  );
};

export default ActionComponentList;
